import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en/common.json";
import enHome from "./locales/en/home.json";
import enLoungeLayout from "./locales/en/loungeLayout.json";
import enHomeLayout from "./locales/en/homeLayout.json";
import si from "./locales/si/common.json";
import siHome from "./locales/si/home.json";
import siHomeLayout from "./locales/si/homeLayout.json";
import hi from "./locales/hi/common.json";
import hiHome from "./locales/hi/home.json";
import hiHomeLayout from "./locales/hi/homeLayout.json";
import ta from "./locales/ta/common.json";
import taHome from "./locales/ta/home.json";
import taHomeLayout from "./locales/ta/homeLayout.json";
import fr from "./locales/fr/common.json";
import frHome from "./locales/fr/home.json";
import frHomeLayout from "./locales/fr/homeLayout.json";

const initialLang = localStorage.getItem("cm_lang") || "en";

i18n.use(initReactI18next).init({
  resources: {
     en: { common: en, home: enHome, homeLayout: enHomeLayout, loungeLayout: enLoungeLayout },
    si: { common: si, home: siHome, homeLayout: siHomeLayout },
    hi: { common: hi, home: hiHome, homeLayout: hiHomeLayout },
    ta: { common: ta, home: taHome, homeLayout: taHomeLayout },
    fr: { common: fr, home: frHome, homeLayout: frHomeLayout },
  },
  lng: initialLang,
  fallbackLng: "en",
  ns: ["common", "home", "homeLayout", "loungeLayout"],
  defaultNS: "common",
  interpolation: { escapeValue: false },
});

// keep <html lang="..."> in sync
i18n.on("languageChanged", (lng) => {
  document.documentElement.setAttribute("lang", lng || "en");
});

export default i18n;
